/**
 * Vuex types
 */
export const LOGIN = 'USER_SIGNIN'
/**
 * 登出
 */
export const LOGOUT = 'USER_SIGNOUT'
/**
 * 生成路由
 */
export const GENERATEROUTES = 'GENERATE_ROUTES'

export const TOKEN = 'TOKEN'

export const REFRESH = 'REFRESH'

export const USERINFO = 'GET_USER_INFO'

export const LOCAL_TOKEN = 'ad_token';
export const MENU = 'menu';
export const K12TYPE = '1'; // k12学校类型
export const UNK12TYPE = '2'; // 非K12学校类型


// WEBPACK FOOTER //
// ./src/stores/types.js